import "./AssignedToText.scss";

import { observer } from "mobx-react";
import React from "react";
import Popup from "reactjs-popup";

import { Flex, Typography } from "@/components/Elements";
import { useMainStore } from "@/contexts/Store";

import { getAssignedToText } from "./helpers";

export type AssignedToTextProps = { assigneeIDs: number[] };

export const AssignedToText = observer((props: AssignedToTextProps) => {
  const mainStore = useMainStore();

  const assignedDisplayUsers = mainStore.users.allDisplayUsers.filter((user) =>
    props.assigneeIDs.includes(user.id),
  );

  if (!assignedDisplayUsers.length) {
    return null;
  }

  const assignedToText = getAssignedToText(assignedDisplayUsers);

  return (
    <Popup
      on="hover"
      trigger={
        <div>
          <Typography
            className="assigned-to-text"
            color="extrasBlueGrayDarker"
            size="xs"
            label={assignedToText}
          />
        </div>
      }
    >
      <Flex column className="assigned-to-text__tooltip">
        {assignedDisplayUsers.map(({ display, id }) => (
          <Typography key={id} label={display} size="xs" color="generalWhite" />
        ))}
      </Flex>
    </Popup>
  );
});
